/* RESPONSIBLE TEAM: team-phone */
import {
  TRIGGERABLE_BOT_TYPE,
  PHONE_CALL_ENDED_TARGET,
  PHONE_CALL_ENDED_TRIGGER,
  DURING_CONVERSATION,
  NON_VISITOR_ROLE_PREDICATE,
  WORKFLOWS_SETUP_TRIGGER_DURING_CONVERSATION,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import PhoneCallEndedEditorConfig from 'embercom/objects/visual-builder/configuration/editor/phone-call-ended';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

import CustomBotConfig from '../custom-bot';
import type { BotConfigTarget } from '../configuration';

export default class PhoneCallEndedBotConfig extends CustomBotConfig {
  get rolePredicateGroup() {
    return { predicates: [NON_VISITOR_ROLE_PREDICATE] };
  }

  get target(): BotConfigTarget {
    return PHONE_CALL_ENDED_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return PHONE_CALL_ENDED_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.phone-call-ended.title';
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.phone-call-ended.description';
  }

  get icon(): InterfaceIconName {
    return 'phone';
  }

  get editorConfig() {
    return new this.EditorConfigClass({
      targetChannels: this.customBot?.targetChannels,
      areStepPaywallsActive: this.areStepPaywallsActive,
      workflow: this.workflow,
    });
  }

  get EditorConfigClass() {
    return PhoneCallEndedEditorConfig;
  }

  visibleToApp(app: any) {
    return app.canUsePhoneCallEndedTrigger as boolean;
  }

  get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  get triggerContextType() {
    return DURING_CONVERSATION;
  }

  get workflowsSetupTriggerType(): string[] {
    return [WORKFLOWS_SETUP_TRIGGER_DURING_CONVERSATION];
  }
}
